import { observable, action } from 'mobx';
import ApiCaller from '../utils/api-caller';
import Format from '../utils/format';
import moment from 'moment';
import { v4 } from 'uuid';

class retailOfferStore {

    // Properties

    @observable retailOffers = [];
    @observable retailOfferId = 0;
    @observable taskId = 0;
    @observable taskName = '';

    @observable title = '';
    @observable briefDesc = '';
    @observable description = '';
    @observable retailOfferLanguages = [];

    @observable price = 0;
    @observable originalPrice = 0;

    @observable startDate = undefined;
    @observable startTime = undefined;

    @observable endDate = undefined;
    @observable endTime = undefined;

    @observable originalImageUrl = '';
    @observable imageUrl = '';
    @observable images = [];

    @observable sort = 1;

    @observable showBannerOnly = false;

    @observable lastChildItems = [];
    @observable lastChildItemFilter = [];

    @observable showUpdateRetailOfferModal = undefined;
    @observable showSearchMenuItemModal = undefined;

    @observable itemSearchValue = '';

    @observable manageRetailOfferTitle = '';

    @observable updateLoading = false;

    @action init() {
        this.setShowUpdateRetailOfferModal(false);
        this.setShowSearchMenuItemModal(false);

        return ApiCaller.RetailOffer.GetAll().then((retailOfferResponses) => {
            retailOfferResponses.map((retailOfferReponse) => {
                retailOfferReponse.startDate = Format.DateTime(retailOfferReponse.startDate);
                retailOfferReponse.endDate = Format.DateTime(retailOfferReponse.endDate);

                return retailOfferReponse;
            })

            this.retailOffers = retailOfferResponses;

            const languageCode = window.localStorage.getItem('lang') || 'en';
            ApiCaller.CmsTasks.getShoppingAll(languageCode).then((fnbResponse) => {
                if (fnbResponse) {
                    if (fnbResponse.items.length > 0) {
                        this.lastChildItems = fnbResponse.items;
                        this.lastChildItemFilter = this.lastChildItems;
                    }
                }

                this.updateLoading = false;
            })
        })
    }

    @action initCreate(activeLanguages) {
        this.manageRetailOfferTitle = 'Add Shopping Offer';

        this.retailOfferId = 0;
        this.taskId = undefined;
        this.taskName = '';

        this.title = '';
        this.briefDesc = '';
        this.description = '';
        this.retailOfferLanguages = [];

        if (activeLanguages) {
            activeLanguages.forEach(lang => {
                this.retailOfferLanguages.push({
                    retailOfferLangId: 0,
                    retailOfferId: 0,
                    langId: lang.id,
                    title: '',
                    briefDesc: '',
                    description: ''
                });
            });
        }

        this.price = 0;
        this.originalPrice = 0;
        this.imageUrl = '';
        this.images = [{
            id: v4(),
            url: '',
            isLoading: false
        }];
        this.showBannerOnly = false;
        this.sort = 1;

        const today = moment();
        this.setStartDate(today);
        this.setStartTime(today);
        this.setEndDate(today);
        this.setEndTime(today);

        this.showUpdateRetailOfferModal = true
    }

    @action initUpdate(value, activeLanguages) {
        this.retailOfferId = value;
        this.manageRetailOfferTitle = 'Update Shopping Offer';

        return ApiCaller.RetailOffer.GetById(this.retailOfferId).then((response) => {
            if (response) {
                this.retailOfferId = response.retailOfferId;
                this.taskId = response.taskId;
                this.taskName = response.taskName;

                this.title = response.title;
                this.briefDesc = response.briefDesc;
                this.description = response.description;
                this.retailOfferLanguages = response.retailOfferLanguages || [];
                if (activeLanguages) {
                    activeLanguages.forEach(lang => {
                        const existingLang = this.retailOfferLanguages.find(item => item.langId === lang.id);
                        if (!existingLang) {
                            this.retailOfferLanguages.push({
                                retailOfferLangId: 0,
                                retailOfferId: this.retailOfferId,
                                langId: lang.id,
                                title: '',
                                briefDesc: '',
                                description: ''
                            });
                        }
                    });
                }

                this.price = response.price;
                this.originalPrice = response.originalPrice;

                const startDateTime = moment(response.startDate);
                this.setStartDate(startDateTime);
                this.setStartTime(startDateTime);

                const startEndTime = moment(response.endDate);
                this.setEndDate(startEndTime);
                this.setEndTime(startEndTime);

                this.imageUrl = response.imageUrl || '';

                this.images = [];
                if (response.imageUrl) {
                    try {
                        let imagesJson = JSON.parse(response.imageUrl);
                        imagesJson.map(imageJson => {
                            return imageJson.isLoading = false;
                        });
                        this.images = imagesJson;
                    } catch {
                        this.images.push({
                            id: v4(),
                            url: response.imageUrl,
                            isLoading: false
                        });
                    }
                }

                this.images.push({
                    id: v4(),
                    url: '',
                    isLoading: false
                });

                this.showBannerOnly = response.showBannerOnly;
                this.sort = response.sort;

                this.showUpdateRetailOfferModal = true;
            }
        })
    }

    @action searchItemSelected(taskId) {
        const item = this.lastChildItems.find(x => x.taskId === taskId);
        if (item) {
            this.taskId = taskId;
            this.taskName = item.taskName;
            this.originalPrice = item.price;
            this.originalImageUrl = item.imageUrl;
            if (this.imageUrl === '') {
                this.imageUrl = this.originalImageUrl;

                this.images.push({
                    id: v4(),
                    url: this.imageUrl,
                    isLoading: false
                });
            }
        } else {
            this.taskId = 0;
            this.taskName = '';
            this.originalPrice = 0;
            this.originalImageUrl = '';
            if (this.imageUrl === '') {
                this.imageUrl = this.originalImageUrl;

                this.images.push({
                    id: v4(),
                    url: this.imageUrl,
                    isLoading: false
                });
            }
        }
    }

    @action searchItem() {
        this.lastChildItemFilter = this.lastChildItems.filter(item => {
            let itemTaskName = item.taskName.toLowerCase();
            return itemTaskName.indexOf(this.itemSearchValue.toLowerCase()) !== -1;
        });
    }

    @action createRetailOffer() {
        this.updateLoading = true;
        const startTime = moment(this.startTime).format('HH:mm:00');
        const endTime = moment(this.endTime).format('HH:mm:00');
        const startDateTime = moment(`${moment(this.startDate).format('YYYY-MM-DD')} ${startTime}`);
        const endDateTime = moment(`${moment(this.endDate).format('YYYY-MM-DD')} ${endTime}`);
        this.imageUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));

        return ApiCaller.RetailOffer.apiCreateRetailOffer(
            this.taskId,
            this.title,
            this.price,
            this.briefDesc,
            this.description,
            startDateTime, endDateTime,
            this.imageUrl, this.showBannerOnly, this.sort,
            this.retailOfferLanguages).then(() => {
                this.init();
            });
    }

    @action updateRetailOffer() {
        this.updateLoading = true;
        const startTime = moment(this.startTime).format('HH:mm:00');
        const endTime = moment(this.endTime).format('HH:mm:00');
        const startDateTime = moment(`${moment(this.startDate).format('YYYY-MM-DD')} ${startTime}`);
        const endDateTime = moment(`${moment(this.endDate).format('YYYY-MM-DD')} ${endTime}`);
        this.imageUrl = JSON.stringify(this.images.filter(fi => fi.url !== ''));

        return ApiCaller.RetailOffer.apiUpdateRetailOffer(
            this.retailOfferId, this.taskId,
            this.title,
            this.price,
            this.briefDesc,
            this.description,
            startDateTime, endDateTime,
            this.imageUrl, this.showBannerOnly, this.sort,
            this.retailOfferLanguages).then(() => {
                this.init();
            });
    }

    @action deleteRetailOffer(retailOfferId) {
        return ApiCaller.RetailOffer.Delete(retailOfferId).then(() => {
            this.init();
        });
    }

    // SET Properties

    @action setRetailOfferId(value) {
        this.retailOfferId = value;
    }

    @action setRetailOfferLanguageTitle(langId, value) {
        let lang = this.retailOfferLanguages.find(fi => fi.langId === langId);
        if (lang) {
            lang.title = value;
            // Set the main title to the primary language (English, langId = 1)
            if (langId === 1) {
                this.title = value;
            }
        }
    }

    @action setRetailOfferLanguageBriefDesc(langId, value) {
        let lang = this.retailOfferLanguages.find(fi => fi.langId === langId);
        if (lang) {
            lang.briefDesc = value;
            // Set the main briefDesc to the primary language (English, langId = 1)
            if (langId === 1) {
                this.briefDesc = value;
            }
        }
    }

    @action setRetailOfferLanguageDescription(langId, value) {
        let lang = this.retailOfferLanguages.find(fi => fi.langId === langId);
        if (lang) {
            lang.description = value;
            // Set the main description to the primary language (English, langId = 1)
            if (langId === 1) {
                this.description = value;
            }
        }
    }

    @action setItemSearchValue(value) {
        this.itemSearchValue = value;
    }

    @action setShowUpdateRetailOfferModal(value) {
        this.showUpdateRetailOfferModal = value;
    }

    @action setShowSearchMenuItemModal(value) {
        this.showSearchMenuItemModal = value;
    }

    @action setPrice(value) {
        this.price = value;
    }

    @action setOriginalPrice(value) {
        this.originalPrice = value;
    }

    @action setStartDate(value) {
        this.startDate = value;
    }

    @action setStartTime(value) {
        this.startTime = value;
    }

    @action setEndDate(value) {
        this.endDate = value;
    }

    @action setEndTime(value) {
        this.endTime = value;
    }

    @action setImageUrl(value) {
        this.imageUrl = value;
    }

    @action setImageUrlAsOriginalImageUrl() {
        this.imageUrl = this.originalImageUrl;
    }

    @action setShowBannerOnly(value) {
        this.showBannerOnly = value;
    }

    @action setsort(value) {
        this.sort = value;
    }

    @action setImageUrlById(id, value) {
        let image = this.images.find(fi => fi.id === id);
        if (image) {
            image.url = value;
        }

        let blankImage = this.images.find(fi => fi.url === '');
        if (!blankImage) {
            this.images.push({
                id: v4(),
                url: '',
                isLoading: false
            });
        }
    }

    @action setImageIsLoadingById(id, isLoading) {
        let image = this.images.find(fi => fi.id === id);
        if (image) {
            image.isLoading = isLoading;
        }
    }

    @action removeImageById(id) {
        this.images = this.images.filter(fi => fi.id !== id);
    }
}

export default new retailOfferStore()